import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Flex, Text } from 'core/ui/atoms';
import { ReactComponent as MastercardIcon } from 'core/assets/images/V2/icons/MastercardIcon.svg';
import { ReactComponent as VisaIcon } from 'core/assets/images/V2/icons/VisaIcon.svg';

const PaymentCard = (props) => {
  const { billingInfo = {} } = props;
  const { last4, expMonth, expYear, brand } = (billingInfo || {});

  if (!last4) {
    return <Text data-card-none>None</Text>;
  }

  const Brand = () => {
    switch (brand) {
      case 'Visa':
        return <VisaIcon />;
      default:
        return <MastercardIcon />;
    }
  };

  return (
    <Flex direction='row' alignItems='center'>
      <Brand />
      <CardText>&nbsp;&nbsp;****{last4}</CardText>
      <CardText>&nbsp;{`(${expMonth}/${expYear})`}</CardText>
    </Flex>
  );
};

const CardText = styled(Text)`
  color: #36443A;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
`;

PaymentCard.propTypes = {
  billingInfo: PropTypes.object,
};

export default PaymentCard;
